import { createStyles } from 'antd-style'

export const useStyle = createStyles(({ token, css }) => {
  return {
    menuCollapsed: css`
      width: 74px;
      display: flex;
      flex-direction: column;
      align-items: center;
      background: #f6f8fa;
      z-index:10;
      @media (max-width: 1000px) {
        // 🌟 核心修改：在移动端彻底隐藏
        width: 0 !important;
        min-width: 0 !important;
        overflow: hidden;
        padding: 0 !important;
        border: none;
        opacity: 0;
        pointer-events: none; // 防止点击到隐藏的元素
      }
    `,
    menu: css`
      background: #f6f8fa;
      width: 260px;
      height: 100%;
      display: flex;
      flex-direction: column;
      padding: 0 16px;
      box-sizing: border-box;
      overflow-y: auto;
      overflow-x: hidden;
      transition: width 0.2s ease-in-out;
      border-right: 1px solid #e9ebef;
      z-index:10;
      @media (max-width: 1000px) {
        position: fixed; // 移动端建议悬浮，不占用页面空间
        z-index: 1000;
      }
    `,
    userProfile: css`
      display: flex;
      height: 30px;
      width: 100%;
      justify-content: center;
      gap: 28px;
      align-items: center;
      padding: 16px 0;
      border-bottom: 1px solid #f1f2f5;
      margin-bottom: 12px;
    `,
    functionMenu: css`
      margin-bottom: 8px;
      padding: 4px 0;
      border-bottom: 1px solid #f1f2f5;
    `,

    functionMenuItem: css`
      padding: 8px 16px;
      cursor: pointer;
      border-radius: ${token.borderRadius}px;
      display: flex;
      align-items: center;
      height: 24px;
      &:hover {
        background: #ffffff;
        transform: scale(1.05);
      }

      span {
        font-size: 14px;
      }
    `,
    conversationHistory: css`
      width: 138px;
      height: 24px;
      font-size: 14px;
      color: #212329;
      line-height: 24px;
      font-weight: 700;
      margin-left: 12px;
      margin-bottom: 8px;
    `,
    conversationsContainer: css`
      display: flex;
      flex-direction: column;
      gap: 8px;
      flex: 1;
      overflow: hidden;
      position: relative;
    `,
    conversationsScrollContainer: css`
      height: 100%;
      overflow: auto;
      padding-right: 2px;
    `,

    conversationTitle: css`
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      flex: 1;
      font-size: 13px;
    `,

    deleteButton: css`
      &.ant-btn {
        padding: 0 4px;
        min-width: 24px;
        height: 24px;
      }
    `,

    collapsedMenuBtn: css`
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: ${token.boxShadowSecondary};
      cursor: pointer;
      opacity: 1;
      transform: scale(1);

      &:hover {
        transform: scale(1.05);
      }
    `,
    bottomLinkWrapper: css`
      position: absolute;
      left: 20px;
      bottom: 8px;
      z-index: 10;
    `,
  }
})
